import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=652f7a9a&scoped=true"
import script from "./SignUpModal.vue?vue&type=script&lang=ts"
export * from "./SignUpModal.vue?vue&type=script&lang=ts"
import style0 from "./SignUpModal.vue?vue&type=style&index=0&id=652f7a9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652f7a9a",
  null
  
)

export default component.exports